// Admin-only warning: the kitchen flow is switched on but its first-boot
// setup did not finish (pilot fix, Batch 5 lane stock). Every other screen
// keeps working; this only says why the kitchen screens look empty.
import { AlertTriangle } from 'lucide-react'
import { kitchenFlowSetupUnfinished, useAllSettings } from '@/hooks/useKitchenFlowEnabled'
import { T } from '@/lib/inventoryFlow/strings'

export function KitchenFlowSetupBanner({ role }: { role: string | null | undefined }) {
  const settings = useAllSettings()
  if (!kitchenFlowSetupUnfinished(settings, role)) return null
  return (
    <div role="alert" className="flex shrink-0 items-start gap-2 border-b border-border bg-warning-surface px-4 py-2 text-sm text-warning-fg">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <span>{T.setupUnfinished}</span>
    </div>
  )
}
